import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Card, renderRow } from 'components';
import { useLoading, useLocalErrorHandler } from 'hooks';
import { formatFullAddress } from '_helpers';

const DetailsContainer: React.FC<Props> = (props) => {
    useLocalErrorHandler(props.setErrorHandler);

    const [processing, fetchDetails] = useLoading(props.getDetails);

    useEffect(() => {
        fetchDetails();

        return () => {
            props.clearDetails();
        };
    }, []);

    return (
        <Card
          title="Информация по АЦ"
          category="Общая информация по аккредитационному центру"
          apiError={props.apiError}
          showLoader={processing}
          show404Error={!props.info}
        >
            {props.info && (
                <section>

                    {renderRow('СОКР. НАЗВАНИЕ', props.info.name)}
                    {renderRow('ПОЛНОЕ НАЗВАНИЕ', props.info.fullName)}
                    {renderRow('РЕГИОН', props.info.regionName)}
                    {renderRow('ГОРОД', props.info.city)}
                    {renderRow('АДРЕС', formatFullAddress(props.info))}

                </section>
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    info: state.general.info,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getDetails: dispatch.general.getInfoAsync,
    clearDetails: dispatch.general.clearInfo,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(DetailsContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
